import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e57bac08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-container"
}
const _hoisted_2 = { class: "info-item van-hairline--top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保单状态", -1))
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = {
  key: 1,
  class: "xag-page__footer footer nongfu-button-wrap"
}
const _hoisted_7 = {
  key: 2,
  class: "xag-page__footer footer nongfu-button-wrap"
}
const _hoisted_8 = {
  key: 3,
  class: "xag-page__footer footer nongfu-button-wrap"
}

import { Button } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { onUnmounted, Ref, ref, computed } from 'vue'
import {
  getInsuranceStatusClassName,
  getInsuranceStatusDesc,
  judgeJijiaInsuranceCanRefund,
  judgeJijiaInsuranceCanDonwload,
} from '../common'
import { commonErrorHandle } from '@/utils/error-handle'
import { CachePinanOrderPayed } from '@/config/insurance'
import { useCommon } from '@/compositions/insurance/index'
import { IframeWrapWindowtHistoryKey } from '@/config/constant'
import { JijiaDeviceCardInfoListItem, ClientJijiaInsuranceDetail } from '@/types/insurance'
import { usePinanPay, useMultiplatformOrderAdaptation } from '@/compositions/insurance/usePay'
import {
  clearToast,
  showToastLoading,
  showConfirmModal,
  showToastSuccess,
  showToastFail,
} from '@/utils/tools'
import { getClientJijiaInsuranceDetail, cancelWaitPayJijiaInsuranceOrder } from '@/apis/insurance'
import AppHeader from '@/components/Header.vue'
import DeviceCardInfo from '../components/device-card-info-old.vue'
import insuranceTagItem from '../components/insurance-tag-item.vue'
import JijiaRefundPopup from '../components/jijia-refund-popup.vue'
import JijiaInsuranceTips from '../components/jijia-insurance-tips.vue'
import { InsuranceJijiaOrderRefundDataStorage } from '@/storage/insurance'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-detail',
  setup(__props) {

const $route = useRoute()
const $router = useRouter()
const policy_no = $route.query.policy_no as string
const eq_sn = $route.query.eq_sn as string
const id = $route.query.id as string
const isPayed = ($route.query.from as string) === 'payed' // 如果是平安支付完成后过来的，由于后端回调还没完成，可能还只是未支付
const isFromAppInsuranceDetail = ($route.query.type as string) === 'appInsuranceDetail' // 判断是否从农服设备详情过来
const loading = ref(false)
const { downloadPolicyOrder, canQuotaReplenishment, checkQuotaReplenishment } = useCommon()
const { payHandle } = usePinanPay()
const { payLinkAdaptationJudge } = useMultiplatformOrderAdaptation()
const deviceInfo: Ref<JijiaDeviceCardInfoListItem | null> = ref(null)
const statuText = ref('')
const statusClass = ref('')
const waitPay = ref(false)
const pay_link = ref('')
const showPopup = ref(false)
const detail: Ref<ClientJijiaInsuranceDetail | null> = ref(null)
const isCanRefund = computed(() => {
  if (!detail.value) {
    return false
  }
  return judgeJijiaInsuranceCanRefund(detail.value)
})
const isCanDownload = computed(() => {
  if (!detail.value) {
    return false
  }
  return judgeJijiaInsuranceCanDonwload(detail.value)
})
let timeId = 0
let count = 1
const infoList: Ref<
  Array<{
    label: string
    value: string
  }>
> = ref([])

function confirmHandle() {
  const params = {
    pay_link: pay_link.value,
    eq_sn,
    effect_time: detail.value?.policy_start_at,
    created_at: detail.value?.created_at,
    id: detail.value.id,
    is_applets: detail.value.is_applets,
  }
  if (!payLinkAdaptationJudge(params)) {
    return
  }
  payHandle(params)
}
async function cancelOrderHandle() {
  await showConfirmModal({
    title: '撤销保单',
    message: '确认是否撤销保单？',
    className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
  })
  void requestCancelOrder()
}
async function requestCancelOrder() {
  showToastLoading()
  try {
    await cancelWaitPayJijiaInsuranceOrder(detail.value.apply_policy_no)
    showToastSuccess('撤销成功')
    setTimeout(() => {
      initPageData(false)
    }, 2000)
  } catch (error) {
    commonErrorHandle(error)
  }
}
function loopSearch() {
  console.log('222', localStorage.getItem('testCache'))
  timeId = setTimeout(() => {
    initPageData()
  }, 3000)
}
function onLeftClick() {
  if (isPayed) {
    // 理论上小程序不会有返回键，app上支付后如果是支付宝方式，是嵌套在iframe里的，也不会有；只有微信支付时会出现这种情况
    // 支付后的
    // const originUrl =
    //   location.origin === 'https://xservice.xa.com/'
    //     ? 'https://argi-service-front.xag.cn'
    //     : 'https://agri-service-test.xair.cn:9093'
    // location.href = originUrl + '/#/purchase-guidelines'
    const startLength = Number(sessionStorage.getItem(IframeWrapWindowtHistoryKey))
    $router.go(-1 * (window.history.length - startLength + 1))
  } else {
    $router.go(-1)
  }
}
function toRefundHandle() {
  if (detail.value?.operation?.operation_status === 0) {
    showConfirmModal({
      title: '申请退保失败',
      message: detail.value.operation.message,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
    return
  }
  InsuranceJijiaOrderRefundDataStorage.set(detail.value)
  $router.push({
    name: 'insurance-service-jijia-order-refund',
  })
}

// 去往额度补充
function toQuotaReplenishment() {
  $router.push({
    name: 'insurance-jijia-insurance-form-page',
    query: {
      sn: eq_sn,
      replenishment: 1,
    },
  })
}
async function initPageData(bool = true) {
  showToastLoading()
  if (bool) {
    loading.value = true
  }
  try {
    const params: Record<string, string> = {}
    if (id) {
      params.id = id
    } else if (eq_sn) {
      params.eq_sn = eq_sn
    } else if (policy_no) {
      params.policy_no = policy_no
    }
    const data = await getClientJijiaInsuranceDetail(params)
    await checkQuotaReplenishment(data)
    if (isPayed) {
      // 兼容平安支付后回到这个页面时，加上标识，后续会提到设备列表页可以正常更新
      sessionStorage.setItem(CachePinanOrderPayed, '1')
    }
    if (isPayed && data.status === 1 && count < 100) {
      //支付完成后跳转过来，但状态码还没更新时需要轮询
      if (localStorage.getItem('isCancelPayed')) {
        localStorage.removeItem('isCancelPayed')
      } else {
        loopSearch()
        count++
        return
      }
    }

    detail.value = data
    deviceInfo.value = {
      sn: data.eq_sn,
      headInfo: {
        name: data.eq_name || data.eq_model_name,
        img: data.eq_logo,
        mainInfos: [`SN：${data.eq_sn}`, `设备型号：${data.eq_model_name}`],
        sn: data.eq_sn,
        model: data.eq_model_name,
        activeTime: data.activate_at,
      },
      useCustom: true,
    }
    const insuranceType =
      data.insurance_type === 1 ? '首保' : data.insurance_type === 2 ? '首年二保' : ''
    const version = data.product_info?.pro_version || ''
    infoList.value = [
      { label: '保单号', value: data.policy_no },
      {
        label: '保险产品',
        value: data.product_info.product_name,
      },
      { label: '保险生效时间', value: data.policy_start_at.split(' ')[0] },
      { label: '保险到期时间', value: data.policy_end_at.split(' ')[0] },
      { label: '初始保额', value: data.amount },
      { label: '已使用额度', value: data.use_amount },
      { label: '剩余额度', value: data.remain_amount },
      { label: '投保时间', value: data.created_at.split(' ')[0] },
    ]
    statuText.value = getInsuranceStatusDesc(data.status, data.status_desc)
    waitPay.value = data.status === 1
    pay_link.value = data.pay_link
    statusClass.value = getInsuranceStatusClassName(data.status, data.status_desc)
    clearToast()
  } catch (error) {
    console.log('error', error)
    commonErrorHandle(error)
  }
  loading.value = false
}
function downloadOrder() {
  if (!detail.value?.policy_no) {
    showToastFail('无保险单号,下载失败')
    return
  }
  downloadPolicyOrder(detail.value?.policy_no)
}
initPageData()
try {
  window.parent?.watchMessage(
    JSON.stringify({
      title: '保单详情',
    })
  )
} catch (error) {
  console.log('error', error)
}
onUnmounted(() => {
  clearTimeout(timeId)
  clearToast()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "保单详情",
      onLeftClick: onLeftClick,
      isReturnLeftEvent: ""
    }),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (deviceInfo.value)
              ? (_openBlock(), _createBlock(DeviceCardInfo, {
                  key: 0,
                  data: deviceInfo.value,
                  imgSize: 72,
                  class: "custom-device-card"
                }, {
                  customRight: _withCtx(() => [
                    (_unref(isCanDownload))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "download-btn",
                          onClick: downloadOrder
                        }, "下载保单"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(insuranceTagItem, {
                text: statuText.value,
                className: statusClass.value
              }, null, 8, ["text", "className"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "info-item van-hairline--top",
                key: index
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.value || '-'), 1)
              ]))
            }), 128))
          ]),
          _createVNode(JijiaInsuranceTips),
          _createVNode(JijiaRefundPopup, {
            show: showPopup.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopup).value = $event)),
            detail: detail.value,
            onUpdateList: _cache[1] || (_cache[1] = ($event: any) => (initPageData(true)))
          }, null, 8, ["show", "detail"])
        ]))
      : _createCommentVNode("", true),
    (!loading.value && waitPay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (detail.value && detail.value.operation.operation_status === 1)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "cancel-button xa-vant-button",
                round: "",
                onClick: cancelOrderHandle
              }, {
                default: _withCtx(() => [
                  _createTextVNode("撤销保单")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(Button), {
            class: "confirm-button xa-vant-button",
            round: "",
            onClick: confirmHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("立即支付")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !waitPay.value && _unref(isCanRefund) && isFromAppInsuranceDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(Button), {
            class: "confirm-button refund-button xa-vant-button",
            round: "",
            onClick: toRefundHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("申请退保")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!loading.value && _unref(canQuotaReplenishment))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(Button), {
            class: "confirm-button quota-replenishment-button xa-vant-button",
            round: "",
            onClick: toQuotaReplenishment
          }, {
            default: _withCtx(() => [
              _createTextVNode("意外险额度补充")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})